import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import './CustomTab.scss';

const CustomTab = ({ tabHeading, tabContent, takeIndex }) => {
	const [value, changeValue] = useState(0);

	const handleChange = (event, value) => {
		changeValue(value);
		takeIndex(value)
	};

	return (
		<React.Fragment>
			<Tabs
				value={value}
				onChange={handleChange}
				classes={{ root: 'tabs-root', indicator: 'tabs-indicator' }}
				indicatorColor="primary"
				textColor="primary"
				centered
			>
				{tabHeading.map(item => (
					<Tab
						key={item.id}
						disableRipple
						label={item.name}
						classes={{ root: 'tab-root', selected: 'tab-selected' }}
					/>
				))}
			</Tabs>
			{tabContent[0]}
		</React.Fragment>
	);
};

CustomTab.propTypes = {
	tabHeading: PropTypes.instanceOf(Array),
	tabContent: PropTypes.instanceOf(Array)
};

CustomTab.defaultProps = {
	tabHeading: [],
	tabContent: []
};

export default CustomTab;



// WEBPACK FOOTER //
// ./common/CustomTab/CustomTab.js